import XLSX from 'xlsx'

export const writeFile = (tableData,colunm,fileNmae)=>{
    var wb = XLSX.utils.book_new(); /* 获取二进制字符串作为输出 */
    let arr = tableData.map((t)=>{
      let newJson = {}
      colunm.forEach(k=>{
        for(let key in t){
          if(k.key === key){
            newJson[k.label] = k.render ? k.render(t[key]):t[key]
          }
        }  
      })
      return newJson
    })
    wb.SheetNames[0]= 'Sheet1'
    wb.Sheets[wb.SheetNames[0]]= XLSX.utils.json_to_sheet(arr)
    XLSX.writeFile(wb,(fileNmae?fileNmae:new Date().getTime()) + '.xlsx')
}


// WEBPACK FOOTER //
// ./src/utils/xlsx.js